import { get } from "helpers/api_helper"
import { ORDER_URL, PRODUCT_URL } from "helpers/url_helper"
import moment from "moment"
import React, { useEffect, useState } from "react"
import Drawer from "react-modern-drawer"
import "react-modern-drawer/dist/index.css"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import { Modal } from "reactstrap"
import { addOrder, getAllOptions } from "store/actions"
import { AddProduct, Trials } from "./components"
import SubDoctor from "./components/add-sub-doctor"
import Teeth from "./components/teeth"
import { post } from "helpers/api_helper"

const isType = false
let t = null
const _priorityOptions = JSON.parse(process.env.REACT_APP_ORDER_PRIORITY)
const _trials = JSON.parse(process.env.REACT_APP_ORDER_TRIALS)
const _articulatorTag = JSON.parse(process.env.REACT_APP_ORDER_ARTICULARTAGS)

const OrderForm = ({
  Position,
  isOpen,
  onDrawerClose,
  title,
  width = 100,
  editableObj,
  client,
  worktype = "new",
  isEditData,
  isViewOnly = false,
  approvalToken = null,
  approvalStatus = null,
  onRequestEditClick = null,
}) => {
  const dispatch = useDispatch()
  const { categories, category_types, product_list } = useSelector(
    state => state.Orders
  )
  const [clientData, setClientData] = useState(false)
  const [priority, setPriority] = useState(0)
  const [isFullMouth, setIsFullMouth] = useState(0)
  const [options, setOptions] = useState(false)
  const [shadesArray, setShadesArray] = useState([])
  const [trailsArray, setTrailsArray] = useState([])
  const [modalType, setModalType] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [productAdded, setProductAdded] = useState([])
  const [isLoadComplete, setIsLoadComplete] = useState(false)
  const [subDoctorsOptions, setSubDoctorsOptions] = useState([])
  const [patientOldOrdes, setPatientOldOrdes] = useState([])
  const [submitLoding, setSubmitLoading] = useState(false)

  const [order, setOrder] = useState({
    worktype: editableObj && isEditData ? editableObj.worktype : worktype,
    order_id: editableObj && isEditData ? editableObj.id : "",
    patient_name: editableObj ? (editableObj.patient_name || "") : "",
    patient_age: editableObj ? (editableObj.patient_age || "") : "",
    case_no: editableObj ? (editableObj.case_no || "") : "",
    client: editableObj ? editableObj?.client : client,
    order_number: editableObj ? (editableObj.order_number || "") : "",
    in_date: editableObj
      ? moment(editableObj.in_date).format("DD-MM-YYYY HH:mm")
      : moment().format("DD-MM-YYYY HH:mm"),
    order_date: editableObj
      ? moment(editableObj.order_date).format("DD-MM-YYYY HH:mm")
      : moment().format("DD-MM-YYYY HH:mm"),
    due_date: editableObj
      ? moment(editableObj.due_date).format("DD-MM-YYYY HH:mm")
      : "",
    priority: editableObj ? (editableObj.priority || 0) : 0,
    shades: [],
    shade_note: editableObj && editableObj.note ? editableObj.note : "",
    trials: [],
    articulator_tag:
      editableObj && editableObj.articular ? editableObj.articular : "",
    sub_doctor: editableObj && (editableObj.doctor || editableObj.sub_doctor) ? (editableObj.doctor || editableObj.sub_doctor) : "",
    correction_template:
      editableObj && editableObj.correction_template
        ? editableObj.correction_template
        : "",
    remark: editableObj ? (editableObj.remark || editableObj.note || "") : "",
    lab_department: editableObj ? (editableObj.department || editableObj.lab_department || "") : "",
    enclosure: {},
    manufacturer: "",
    employee: "",
    products: editableObj ? editableObj?.products : [],
    drop_location: "",
  })

  useEffect(() => {
    if (Object.keys(options)?.length) {
      setIsLoadComplete(true)
    }
  }, [options])

  useEffect(() => {
    if (editableObj?.id) {
      dispatch(getAllOptions({ url: `${PRODUCT_URL}/options`, isType: false }))
    }
  }, [])

  useEffect(() => {
    if (editableObj) {
      getData(editableObj?.client)
      if (editableObj?.shade) {
        try {
          const s = typeof editableObj.shade === "string" ? JSON.parse(editableObj.shade) : editableObj.shade
          setShadesArray(Array.isArray(s) ? s : [])
        } catch (e) {
          console.error("Error parsing shades:", e)
        }
      }
      if (editableObj?.trial) {
        const tArr = typeof editableObj.trial === "string" ? editableObj.trial.split(",") : (Array.isArray(editableObj.trial) ? editableObj.trial : [])
        setTrailsArray(tArr)
        setOrder(prev => ({ ...prev, trials: editableObj.trial }))
      }
      if (editableObj?.articular) {
        setOrder(prev => ({ ...prev, articulator_tag: editableObj?.articular }))
      }
      if (editableObj?.enclosure) {
        try {
          const a = typeof editableObj.enclosure === "string" ? JSON.parse(editableObj.enclosure) : editableObj.enclosure
          setOrder(prev => ({ ...prev, enclosure: a || {} }))
        } catch (e) {
          console.error("Error parsing enclosure:", e)
        }
      }
      if (editableObj?.priority !== undefined) {
        setPriority(editableObj.priority)
      }
      if (editableObj?.is_full_mouth !== undefined) {
        setIsFullMouth(parseInt(editableObj.is_full_mouth) || 0)
      }

      setOrder(prev => ({
        ...prev,
        worktype: isEditData && editableObj.worktype ? editableObj.worktype : prev.worktype,
        order_id: isEditData && editableObj.id ? editableObj.id : prev.order_id,
        patient_name: editableObj.patient_name !== undefined ? (editableObj.patient_name || "") : prev.patient_name,
        patient_age: editableObj.patient_age !== undefined ? (editableObj.patient_age || "") : prev.patient_age,
        case_no: editableObj.case_no !== undefined ? (editableObj.case_no || "") : prev.case_no,
        client: editableObj.client || prev.client,
        order_number: editableObj.order_number || prev.order_number,
        in_date: editableObj.in_date ? moment(editableObj.in_date).format("DD-MM-YYYY HH:mm") : prev.in_date,
        order_date: editableObj.order_date ? moment(editableObj.order_date).format("DD-MM-YYYY HH:mm") : prev.order_date,
        due_date: editableObj.due_date ? moment(editableObj.due_date).format("DD-MM-YYYY HH:mm") : prev.due_date,
        priority: editableObj.priority !== undefined ? editableObj.priority : prev.priority,
        shade_note: editableObj.note !== undefined ? (editableObj.note || "") : prev.shade_note,
        articulator_tag: editableObj.articular || prev.articulator_tag,
        sub_doctor: editableObj.doctor || editableObj.sub_doctor || prev.sub_doctor,
        correction_template: editableObj.correction_template || prev.correction_template,
        remark: editableObj.remark !== undefined ? (editableObj.remark || "") : (editableObj.note || prev.remark || ""),
        lab_department: editableObj.department || editableObj.lab_department || prev.lab_department,
      }))

      if (editableObj?.products) {
        const b = editableObj?.products.map(v => {
          let parsedTeeth = []
          try {
            parsedTeeth = typeof v.teeth == "string" ? JSON.parse(v.teeth) : (v.teeth || [])
          } catch (e) {
            parsedTeeth = []
          }
          const u = parseInt(v.units || v.unit || (parsedTeeth ? parsedTeeth.length : 1)) || 1
          const p = parseFloat(v.unitPrice || v.unit_price || 0) || 0
          v.teeth = parsedTeeth
          v.category = v.product_category || v.category
          v.product_category = v.category
          v.categoryTitle = v.categoryTitle
          v.category_type = v.product_type || v.category_type
          v.product_type = v.category_type
          v.categoryTypeTitle = v.categoryTypeTitle
          v.product_id = v.product_id
          v.productListTitle = v.productListTitle
          v.unitPrice = p
          v.unit_price = p
          v.unit = u
          v.units = u
          return v
        })
        setProductAdded(b)
      }

      if (editableObj?.products) {
        let tempCountUnits = 0
        let tempOrderValue = 0

        editableObj?.products?.map((v, i) => {
          const u = parseInt(v.units || v.unit || (v.teeth ? v.teeth.length : 1)) || 1
          const p = parseFloat(v.unitPrice || v.unit_price || 0) || 0
          tempCountUnits += u
          tempOrderValue += u * p
        })
        setOrder(c => ({
          ...c,
          units: tempCountUnits,
          orderValue: tempOrderValue,
        }))
      }
    }
  }, [editableObj])

  const getData = async id => {
    if (id) {
      const res = await get(`api/orders/client/${id}`)
      if (res.status == 200) {
        getSubDoctors(id)
        setClientData(res.response.client)
        setOptions(res.response.options)

        if (worktype == "new")
          setOrder(prev => ({
            ...prev,
            client: res.response.client.code,
            case_no: res.response.client.caseNo,
          }))
      }
    }
  }

  const getSubDoctors = async clientID => {
    const res = await get(
      `api/clients/getsubdoctor?client=${clientID}&option=1`
    )
    if (res?.status === 200) {
      if (editableObj.doctor) {
        const doc = res?.response?.map(v => {
          if (v.value === editableObj.doctor) {
            return { ...v, selected: true }
          }
          return v
        })
        setSubDoctorsOptions(doc)
      } else {
        setSubDoctorsOptions(res?.response)
      }
    }
  }

  useEffect(() => {
    getData(client)
  }, [client])

  useEffect(() => {
    if (shadesArray != null) {
      setOrder(prev => ({ ...prev, shades: shadesArray }))
    }
  }, [shadesArray])

  const getTitle = () => {
    if (modalType) {
      function ucfirst(str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }

      let title = modalType?.replace("_", "")
      return ucfirst(title)
    }
  }

  const encCB = encData => {
    if (encData != null) setOrder(prev => ({ ...prev, enclosure: encData }))
  }

  const getProducts = data => {
    const u = parseInt(data.units || data.unit || (data.teeth ? data.teeth.length : 1)) || 1
    const p = parseFloat(data.unitPrice || data.unit_price || 0) || 0
    const normalized = {
      ...data,
      unit: u,
      units: u,
      unitPrice: p,
      unit_price: p,
      product_category: data.category || data.product_category,
      category: data.category || data.product_category,
      product_type: data.category_type || data.product_type,
      category_type: data.category_type || data.product_type,
    }
    setProductAdded(prev => [...prev, normalized])
  }

  const updateOrderValue = () => {
    let tempCountUnits = 0
    let tempOrderValue = 0
    if (productAdded.length) {
      productAdded?.map((v, i) => {
        const u = parseInt(v.units || v.unit || (v.teeth ? v.teeth.length : 1)) || 0
        const p = parseFloat(v.unitPrice || v.unit_price || 0) || 0
        tempCountUnits += u
        tempOrderValue += u * p
      })
    }
    setOrder(c => ({
      ...c,
      units: tempCountUnits,
      orderValue: tempOrderValue,
      products: productAdded,
    }))
  }

  useEffect(() => {
    updateOrderValue()
  }, [productAdded])

  const addOrderMethods = () => {
    setSubmitLoading(true)
    const callback = () => {
      // redirect("/orders")
      // onDrawerClose()
      // setOrder({
      //   worktype: "new",
      //   order_id: "",
      //   patient_name: "",
      //   patient_age: "",
      //   case_no: "",
      //   client: "",
      //   order_number: "",
      //   in_date: moment().format("DD-MM-YYYY HH:mm"),
      //   order_date: moment().format("DD-MM-YYYY HH:mm"),
      //   due_date: "",
      //   priority: 0,
      //   shades: [],
      //   shade_note: "",
      //   trials: [],
      //   articulator_tag: "",
      //   sub_doctor: "",
      //   correction_template: "",
      //   remark: "",
      //   lab_department: "",
      //   enclosure: {},
      //   manufacturer: "",
      //   employee: "",
      //   products: [],
      //   drop_location: "",
      // })
      // setSubmitLoading(false)
    }

    const orderSummary = (order.products || []).reduce(
      (summary, product) => {
        const price = parseFloat(product.unitPrice || product.unit_price || 0) || 0
        const units = parseInt(product.units || product.unit || (product.teeth ? product.teeth.length : 1)) || 0
        const productValue = price * units
        summary.totalOrderValue += productValue
        summary.totalUnits += units
        return summary
      },
      { totalOrderValue: 0, totalUnits: 0 }
    ) // Initial summary object with totalOrderValue and totalUnits

    console.log({
      Obj: {
        ...order,
        order_value: orderSummary.totalOrderValue,
        orderValue: orderSummary.totalOrderValue,
        units: orderSummary.totalUnits,
        approval_token: approvalToken,
      },
      url: `${ORDER_URL}`,
      isType: isType,
      // callback: callback,
    })

    dispatch(
      addOrder({
        Obj: {
          ...order,
          order_value: orderSummary.totalOrderValue,
          orderValue: orderSummary.totalOrderValue,
          units: orderSummary.totalUnits,
          approval_token: approvalToken,
        },
        url: `${ORDER_URL}`,
        isType: isType,
        callback: callback,
      })
    )
  }

  const removeProductFromOrder = (product, index) => {
    const products = (order.products || productAdded || []).filter((v, i) => i !== index)
    setProductAdded(products)
    setOrder(prevState => ({
      ...prevState,
      products: products,
    }))
  }

  let badgeColor
  useState(() => {
    switch (worktype) {
      case "corr":
        badgeColor = "bg-warning"
      case "redo":
        badgeColor = "bg-danger"
      default:
        badgeColor = "bg-success"
    }
  }, [])

  const getAligners = data =>
    typeof data === "string" ? JSON.parse(data) : data

  const handlePriceEdit = (data, oldIndex) => {
    const val = data.target.value
    const updatedProducts = (order.products || []).map((product, index) => {
      if (index === oldIndex) {
        let temp = {
          ...product,
          unitPrice: val,
          unit_price: val,
          total_amount:
            (parseInt(product.units || product.unit || (product.teeth ? product.teeth.length : 1)) || 0) *
            (parseFloat(val) || 0),
        }
        return temp
      }
      return product
    })

    setOrder(prevState => ({
      ...prevState,
      products: updatedProducts,
    }))
    setProductAdded(updatedProducts)
  }

  const handlePropertyChange = (data, oldIndex, propertyName, keyName) => {
    if (!data) return
    const updatedProducts = (order.products || []).map((product, index) => {
      if (index === oldIndex) {
        let temp = {
          ...product,
          [keyName]: data.value,
          [`${propertyName}Title`]: data.label,
        }
        if (keyName == "product_id") {
          const price = data.price !== undefined && data.price !== null ? data.price : 0
          temp.unitPrice = price
          temp.unit_price = price
          temp.total_amount =
            (parseInt(product.units || product.unit || (product.teeth ? product.teeth.length : 1)) || 0) *
            (parseFloat(price) || 0)
        }
        return temp
      }
      return product
    })

    setOrder(prevState => ({
      ...prevState,
      products: updatedProducts,
    }))
    setProductAdded(updatedProducts)

    // Dispatch additional actions based on the property change
    let url = ""
    let isType = ""

    if (propertyName === "category") {
      url = `${PRODUCT_URL}/options/types?q=${data.value}`
      isType = "types"
    } else if (propertyName === "categoryType") {
      url = `${PRODUCT_URL}/options/product?q=${data.value}&c=${clientData.code}`
      isType = "product"
    }

    // Dispatch the action with the determined URL and isType
    dispatch(getAllOptions({ url, isType }))
  }

  const handleChangeTeeth = (data, oldIndex) => {
    const updatedProduct = (order.products || []).map((product, index) => {
      if (index === oldIndex) {
        let t = []
        if (product.teeth?.length > 0) {
          if (product.teeth.includes(data) && product?.teeth?.length == 1) {
            return {
              ...product,
              teeth: [...product.teeth, data],
            }
          }

          if (product.teeth.includes(data) && product?.teeth?.length != 1) {
            t = product.teeth.filter(item => item !== data)
          } else {
            t = [...product.teeth, data]
          }
        } else {
          t = [data]
        }

        const price = parseFloat(product.unitPrice || product.unit_price || 0) || 0
        return {
          ...product,
          teeth: t,
          units: t.length,
          unit: t.length,
          total_amount: t.length * price,
        }
      }
      return product
    })

    setOrder(prevState => ({
      ...prevState,
      products: updatedProduct,
    }))
    setProductAdded(updatedProduct)
  }

  const handleValidatePatient = async () => {
    if (order.patient_name) {
      const Obj = {
        client: order.client,
        patient: order.patient_name,
      }
      const { status, response } = await post(`${ORDER_URL}/validateorder`, Obj)
      if (status == 200) {
        setPatientOldOrdes(response)
      }
    }
  }

  return (
    <>
      {/* Patient Details Modal */}
      <Drawer
        open={isOpen}
        onClose={onDrawerClose}
        direction={Position}
        style={{
          width: `${width}%`,
        }}
      >
        {isLoadComplete ? (
          <>
            <div className="rightbar-title px-3 py-3 d-flex justify-content-between align-items-center bg-light">
              <h5 className="m-0">
                {isViewOnly ? "VIEW ORDER" : isEditData ? title : worktype == "corr" ? "CORRECTION" : worktype.toUpperCase()}{" "}
                ORDER {order?.order_number ? `#${order.order_number}` : ""}
              </h5>
              <div className="d-flex align-items-center">
                {isViewOnly && onRequestEditClick && (
                  <button
                    type="button"
                    className="btn btn-warning btn-sm me-3 fw-semibold shadow-sm"
                    onClick={onRequestEditClick}
                  >
                    <i className="mdi mdi-lock-alert me-1 font-size-14"></i>
                    {approvalStatus === "pending" ? "Edit Pending Approval" : "Request Edit"}
                  </button>
                )}
                <span
                  className="right-bar-toggle cursor-pointer"
                  title="close"
                  onClick={onDrawerClose}
                >
                  <i className="mdi mdi-close noti-icon font-size-20"></i>
                </span>
              </div>
            </div>

            {isViewOnly && (
              <div className="mx-3 mt-3">
                {approvalStatus === "pending" ? (
                  <div className="alert alert-warning py-2 mb-0 d-flex align-items-center" style={{ fontSize: "13px" }}>
                    <i className="mdi mdi-clock-outline me-2 font-size-18 text-warning"></i>
                    <div>
                      <strong>Approval Pending:</strong> Your edit request for this order is currently waiting for Admin approval.
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-secondary py-2 mb-0 d-flex justify-content-between align-items-center" style={{ fontSize: "13px" }}>
                    <div>
                      <i className="mdi mdi-lock-outline me-2 font-size-18 text-secondary"></i>
                      This order is in <strong>View-Only Mode</strong>. Direct editing is restricted.
                    </div>
                    {onRequestEditClick && (
                      <button className="btn btn-outline-primary btn-sm py-1" onClick={onRequestEditClick}>
                        <i className="mdi mdi-pencil-lock me-1"></i> Request Edit Approval
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

            {approvalToken && (
              <div className="mx-3 mt-3">
                <div className="alert alert-success py-2 mb-0 d-flex align-items-center" style={{ fontSize: "13px" }}>
                  <i className="mdi mdi-check-decagram me-2 font-size-18 text-success"></i>
                  <div>
                    <strong>Authorized for Edit:</strong> You have one-time permission to update this order. Changes will be saved in the audit log.
                  </div>
                </div>
              </div>
            )}

            <div
              style={{
                padding: "20px",
                height: "calc(100vh - 120px)",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {/* ROW_1 */}
              <div className="row">
                {/* 
                                        DIV_1
                                        Client
                                        Case Number
                                        Patien name
                                        Patien Age
                                    */}
                <div className={`col-md-4 mb-3`}>
                  <div className="card" style={{ padding: "10px" }}>
                    <b>
                      {worktype == "corr"
                        ? "CORRECTION"
                        : worktype.toUpperCase()}{" "}
                      CASE NO{" "}
                    </b>
                    <span style={{ borderBottom: "3px solid #f4f4f4" }}>
                      <h2>
                        <span className={`badge bg-dark`}>
                          {editableObj
                            ? editableObj.case_no
                            : clientData.caseNo}
                        </span>
                      </h2>
                    </span>
                    <span id="err_new"></span>
                    <label>Client Name</label>
                    <h2>{clientData?.client || editableObj?.client_name || editableObj?.client || "---"}</h2>

                    <div style={{ display: "flex" }}>
                      <div style={{ width: isViewOnly ? "100%" : "85%" }}>
                        <label>Patient Name</label>
                        <div className="input-group">
                          <input
                            type="text"
                            value={order?.patient_name || ""}
                            readOnly={isViewOnly}
                            className="form-control"
                            onChange={e => {
                              if (isViewOnly) return
                              setOrder(c => ({
                                ...c,
                                patient_name: e.target.value,
                              }))
                            }}
                          />
                          {!isViewOnly && (
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={handleValidatePatient}
                            >
                              Validate
                            </button>
                          )}
                        </div>
                      </div>
                      <div style={{ width: "20%", marginLeft: "10px" }}>
                        <label>Age</label>
                        <input
                          type="number"
                          name="patient_age"
                          value={order?.patient_age || ""}
                          readOnly={isViewOnly}
                          onChange={e => {
                            if (isViewOnly) return
                            setOrder(c => ({
                              ...c,
                              patient_age: e.target.value,
                            }))
                          }}
                          className="form-control"
                        />
                      </div>
                      <span id="err_new"></span>
                    </div>
                  </div>
                </div>
                {/* END DIV_1 */}
                {/* DIV_2 */}
                <div className={`col-md-4`}>
                  <div className="card" style={{ padding: "10px" }}>
                    <div className="row mb-3">
                      <div className={`col-md-6`}>
                        <label
                          className="form-check-label"
                          htmlFor="SwitchCheckSizelg"
                        >
                          Full Mouth{" "}
                        </label>

                        <div
                          className="form-check form-switch form-switch-lg"
                          dir="ltr"
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            disabled={isViewOnly}
                            checked={Boolean(isFullMouth)}
                            onChange={() => {
                              if (isViewOnly) return
                              setIsFullMouth(prev => {
                                const nextVal = !prev ? 1 : 0
                                const day = nextVal
                                  ? moment()
                                    .add(10, "days")
                                    .format("DD-MM-YYYY HH:mm")
                                  : priority > 0
                                    ? moment()
                                      .add(priority, "days")
                                      .format("DD-MM-YYYY HH:mm")
                                    : "xx-xx-xxxx --:--"
                                setOrder(c => ({
                                  ...c,
                                  due_date: day,
                                  is_full_mouth: Boolean(nextVal),
                                  full_mouth_type: "local",
                                }))
                                return nextVal
                              })
                            }}
                          />
                        </div>
                      </div>
                      {isFullMouth > 0 && (
                        <div
                          className={`col-md-6`}
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            marginTop: "25px",
                          }}
                        >
                          <div className="form-check form-radio-primary">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="formRadioColor1"
                              disabled={isViewOnly}
                              defaultChecked={true}
                              onClick={e => {
                                if (isViewOnly) return
                                setOrder(c => ({
                                  ...c,
                                  due_date: moment()
                                    .add(parseInt(10), "days")
                                    .format("D-MM-YYYY HH:mm"),
                                  full_mouth_type: "local",
                                }))
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="formRadioColor1"
                            >
                              Local
                            </label>
                          </div>
                          <div className="form-check form-radio-primary">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="formRadioColor1"
                              disabled={isViewOnly}
                              onClick={e => {
                                if (isViewOnly) return
                                setOrder(c => ({
                                  ...c,
                                  full_mouth_type: "pan_india",
                                  due_date: moment()
                                    .add(parseInt(15), "days")
                                    .format("DD-MM-YYYY HH:mm"),
                                }))
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="formRadioColor1"
                            >
                              Pan India
                            </label>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label>Priority</label>
                      <select
                        name="priority"
                        className="form-control select2"
                        disabled={Boolean(isFullMouth) || isViewOnly}
                        value={order?.priority ?? ""}
                        onChange={e => {
                          if (isViewOnly) return
                          const day = e.target.value
                            ? moment()
                              .add(parseInt(e.target.value), "days")
                              .format("DD-MM-YYYY HH:mm")
                            : "xx-xx-xxxx --:--"
                          setPriority(e.target.value)
                          setOrder(c => ({
                            ...c,
                            due_date: day,
                            priority: e.target.value,
                          }))
                        }}
                      >
                        <option value="" key="PO_0">
                          {" "}
                          ---{" "}
                        </option>
                        {_priorityOptions?.map((v, i) => (
                          <option
                            key={`PO_${i + 1}`}
                            value={v.days}
                            data-id={`${v.id}`}
                          >
                            {v.title}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <label>Order Date</label>
                        <h5>{order?.order_date}</h5>
                      </div>
                      <div className="col-md-6">
                        <label>Due Date</label>
                        <h5>{order?.due_date}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                {/* END DIV_2 */}

                {/* DIV_3 */}
                <div className={`col-md-4`}>
                  <div
                    className="card"
                    style={{ padding: "10px", minHeight: "220px" }}
                  >
                    <label>Shades</label>
                    <Select
                      isDisabled={isViewOnly}
                      value={null}
                      placeholder={isViewOnly ? "Shades selected below" : "Select Shade"}
                      options={options?.shade}
                      onChange={e => {
                        if (isViewOnly || !e) return
                        if (!shadesArray.includes(e.value))
                          setShadesArray(prev => [...prev, e.value])
                      }}
                    />

                    <div style={{ minHeight: "42px" }}>
                      {shadesArray.length
                        ? shadesArray.map((shade, i) => {
                          const shadeObj = options?.shade?.find(v => v.value == shade)
                          return (
                            <span
                              key={`S_${i}`}
                              title={isViewOnly ? undefined : "remove shade"}
                              className="badge rounded-pill bg-primary m-1 shade-badge"
                              style={{
                                padding: "8px 15px",
                                fontSize: "14px",
                                cursor: isViewOnly ? "default" : "pointer",
                              }}
                              onClick={() => {
                                if (isViewOnly) return
                                let temp = shadesArray.filter(
                                  item => item !== shade
                                )
                                setShadesArray(temp)
                                setOrder(c => ({ ...c, shades: temp }))
                              }}
                            >
                              {shadeObj ? shadeObj.label : shade}{" "}
                              {!isViewOnly && <i className="ms-1 mdi mdi-close noti-icon" />}
                            </span>
                          )
                        })
                        : ""}
                    </div>

                    {/* Shade Note Input */}
                    <input
                      name="shade_note"
                      placeholder="Shade Note"
                      className="form-control"
                      readOnly={isViewOnly}
                      value={order?.shade_note || ""}
                      onChange={e => {
                        if (isViewOnly) return
                        setOrder(c => ({ ...c, shade_note: e.target.value }))
                      }}
                    />
                    {/* End Shade Note Input*/}

                    <div className="row mt-1">
                      <label>Trails</label>
                      <div className="col-md-12">
                        {_trials?.map((v, i) => (
                          <span
                            key={"T_" + i}
                            className={`badge rounded-pill ${trailsArray.includes(v) ||
                              order?.trials?.includes(v)
                              ? "bg-success"
                              : "bg-secondary"
                              } m-1 shade-badge`}
                            style={{
                              fontSize: "16px",
                              padding: "3px 15px",
                              cursor: isViewOnly ? "default" : "pointer"
                            }}
                            onClick={() => {
                              if (isViewOnly) return
                              let updated = [...trailsArray]
                              if (!updated.includes(v)) {
                                updated.push(v)
                              } else {
                                updated = updated.filter(k => k !== v)
                              }
                              setTrailsArray(updated)
                              setOrder(c => ({
                                ...c,
                                trials: updated.join(","),
                              }))
                            }}
                          >
                            {" "}
                            {v.toUpperCase()}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/* END DIV_3 */}
              </div>
              {/* END ROW_1 */}

              {/* ROW_2 */}
              <div className="row">
                <div className={`col-md-3`}>
                  <div
                    className="card"
                    style={{
                      minHeight: "280px",
                      padding: "10px",
                      border: "1px solid #f3f3f3",
                    }}
                  >
                    <div className="mb-3">
                      <label>Articulator Tag</label>
                      <select
                        className="form-control select2"
                        disabled={isViewOnly}
                        value={order?.articulator_tag || 0}
                        onChange={e => {
                          if (isViewOnly) return
                          setOrder(c => ({
                            ...c,
                            articulator_tag: e.target.value,
                          }))
                        }}
                      >
                        {_articulatorTag?.map((v, i) => (
                          <option value={v.id} key={`AT_${i}`}>
                            {" "}
                            {v.title}{" "}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label style={{ width: "100%" }}>
                        SubDoctor
                        {!isViewOnly && (
                          <i
                            onClick={e => {
                              setModalType("sub_doctor")
                              setIsOpenModal(!isOpenModal)
                            }}
                            className="fa fa-plus pull-right cursor-pointer"
                            style={{
                              marginTop: "5px",
                              marginRight: "5px",
                              float: "right",
                            }}
                          ></i>
                        )}
                      </label>
                      <Select
                        isDisabled={isViewOnly}
                        value={subDoctorsOptions.find(v => v.value == order?.sub_doctor) || null}
                        options={subDoctorsOptions}
                        onChange={e => {
                          if (isViewOnly) return
                          setOrder(c => ({ ...c, sub_doctor: e ? e.value : "" }))
                        }}
                      />
                    </div>

                    <div className="mb-3">
                      <label>Correction Template</label>
                      <Select
                        isDisabled={isViewOnly}
                        value={options?.correction_temp?.find(
                          v => v.value == order?.correction_template
                        ) || null}
                        options={options?.correction_temp}
                        onChange={e => {
                          if (isViewOnly) return
                          setOrder(c => ({
                            ...c,
                            correction_template: e ? e.value : "",
                          }))
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Remark</label>
                      <textarea
                        className="form-control"
                        rows={3}
                        readOnly={isViewOnly}
                        value={order?.remark || ""}
                        placeholder={isViewOnly ? "No remark" : "Enter remark"}
                        onChange={e => {
                          if (isViewOnly) return
                          setOrder(c => ({ ...c, remark: e.target.value }))
                        }}
                      />
                    </div>
                    <div>
                      <label>Lab Department</label>
                      <Select
                        isDisabled={isViewOnly}
                        value={options?.lab_dep?.find(
                          v => v.value == order?.lab_department
                        ) || null}
                        options={options?.lab_dep}
                        onChange={e => {
                          if (isViewOnly) return
                          setOrder(c => ({ ...c, lab_department: e ? e.value : "" }))
                        }}
                      />
                    </div>
                    <div className="mb-3 mt-3">
                      <label style={{ width: "100%" }}>
                        {"Enclosure"}
                        {!isViewOnly && (
                          <i
                            className="fa fa-plus pull-right cursor-pointer"
                            style={{
                              marginTop: "5px",
                              marginRight: "5px",
                              float: "right",
                            }}
                            onClick={() => {
                              setModalType("enclosure")
                              setIsOpenModal(!isOpenModal)
                            }}
                          ></i>
                        )}
                      </label>
                      {Object.keys(order?.enclosure || {})?.length
                        ? Object.keys(order?.enclosure)
                          .map(v => `${v} : ${order?.enclosure[v]}`)
                          .join(", ")
                        : ""}
                    </div>
                  </div>
                </div>
                <div className="col-md-9">
                  <div
                    className="card border"
                    style={{ minHeight: "280px", padding: "10px" }}
                  >
                    <div className="mb-2 d-flex justify-content-between align-items-center">
                      <h5
                        className="m-0"
                        style={{
                          fontSize: "18px",
                        }}
                      >
                        Products
                      </h5>
                      {!isViewOnly && (
                        <button
                          className="btn btn-primary btn-sm"
                          type="button"
                          onClick={() => {
                            setModalType("add_product")
                            setIsOpenModal(!isOpenModal)
                          }}
                        >
                          <i role="button" className="fa fa-plus me-1"></i> Add Product
                        </button>
                      )}
                    </div>
                    <div className="table-responsive mt-2">
                      <table className="table table-bordered mb-0">
                        <tbody>
                          {order?.products.length > 0 ? (
                            order?.products?.map((v, i) => {
                              t =
                                v.units > 0 && (!v.teeth || v.teeth?.length === 0)
                                  ? v.units
                                  : typeof v.teeth == "string"
                                    ? v.unit
                                    : (v.teeth?.length || v.units || v.unit || 1)
                              return (
                                <React.Fragment key={`product_${v.id || `idx_${i}`}`}>
                                  {i == 0 && (
                                    <tr>
                                      <th>Product Category</th>
                                      <th>Product Type</th>
                                      <th>Product</th>
                                      <th>Teeth</th>
                                      <th>Units</th>
                                      <th>Unit Price</th>
                                      <th>Total</th>
                                    </tr>
                                  )}
                                  <tr
                                    key={`PL_${v.id || i}`}
                                  >
                                    <td>
                                      <Select
                                        isDisabled={isViewOnly}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                        value={
                                          v.product_category || v.category
                                            ? {
                                                label: v.categoryTitle || v.product_category || v.category,
                                                value: v.product_category || v.category,
                                              }
                                            : null
                                        }
                                        options={categories.map(c => ({
                                          label: c.title,
                                          value: c.code,
                                        }))}
                                        onChange={e => {
                                          if (isViewOnly) return
                                          handlePropertyChange(
                                            e,
                                            i,
                                            "category",
                                            "category"
                                          )
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <Select
                                        isDisabled={isViewOnly}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                        value={
                                          v.product_type || v.category_type || v.categoryType
                                            ? {
                                                label: v.categoryTypeTitle || v.product_type || v.category_type || v.categoryType,
                                                value: v.product_type || v.category_type || v.categoryType,
                                              }
                                            : null
                                        }
                                        options={category_types.map(c => ({
                                          label: c.title,
                                          value: c.code,
                                        }))}
                                        onChange={e => {
                                          if (isViewOnly) return
                                          handlePropertyChange(
                                            e,
                                            i,
                                            "categoryType",
                                            "category_type"
                                          )
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <Select
                                        isDisabled={isViewOnly}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                        value={
                                          v.product_id || v.productList
                                            ? {
                                                label: v.productListTitle || v.product_id || v.productList,
                                                value: v.product_id || v.productList,
                                              }
                                            : null
                                        }
                                        options={product_list.map(c => ({
                                          label: `${c.title} (${c.final_price})`,
                                          value: c.code,
                                          price: c.final_price,
                                        }))}
                                        onChange={e => {
                                          if (isViewOnly) return
                                          handlePropertyChange(
                                            e,
                                            i,
                                            "productList",
                                            "product_id"
                                          )
                                        }}
                                      />
                                    </td>
                                    <td style={{ width: "100px" }}>
                                      {v.units > 0 && v.teeth?.length == 0 ? (
                                        <table
                                          key={`alg_${Math.round(
                                            Math.random() * 100
                                          )}`}
                                          className={`teeth_table`}
                                        >
                                          <tbody>
                                            <tr
                                              key={`AL_${Math.round(
                                                Math.random() * 100
                                              )}`}
                                            >
                                              <td>Upper Aligner</td>
                                              <td>
                                                {getAligners(v.aligners).upperSet}
                                              </td>
                                            </tr>
                                            <tr
                                              key={`AL_${Math.round(
                                                Math.random() * 100
                                              )}`}
                                            >
                                              <td>Lower Aligner</td>
                                              <td>
                                                {getAligners(v.aligners).lowerSet}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      ) : (
                                        <Teeth
                                          values={v.teeth || []}
                                          callback={data => {
                                            if (isViewOnly) return
                                            handleChangeTeeth(data, i)
                                          }}
                                        />
                                      )}
                                    </td>
                                    <td>{t}</td>
                                    <td>
                                      <input
                                        type="number"
                                        readOnly={isViewOnly}
                                        className="form-control"
                                        value={v.unitPrice !== undefined && v.unitPrice !== null ? v.unitPrice : ""}
                                        onChange={e => {
                                          if (isViewOnly) return
                                          handlePriceEdit(e, i)
                                        }}
                                        onBlur={e => {
                                          if (isViewOnly) return
                                          handlePriceEdit(e, i)
                                        }}
                                      />
                                    </td>
                                    <td>{((parseFloat(v.unitPrice || v.unit_price || 0) || 0) * (parseFloat(t) || 0))}</td>
                                  </tr>
                                  <tr key={`PLN_${i}`}>
                                    <td colSpan="6">
                                      <label>Margins</label> : NA,{" "}
                                    </td>
                                    <td>
                                      {!isViewOnly && (
                                        <button
                                          type="button"
                                          onClick={() =>
                                            removeProductFromOrder(v, i)
                                          }
                                          className="btn btn-danger btn-sm"
                                        >
                                          <i className="fas fa-trash-alt" />
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={7} style={{ textAlign: "center" }}>
                                No Products Added
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {/* END ROW_2 */}

              <div className="mt-3 mb-4 d-grid">
                {isViewOnly ? (
                  onRequestEditClick ? (
                    <button
                      style={{ height: "60px" }}
                      className="btn btn-warning fw-bold"
                      type="button"
                      onClick={onRequestEditClick}
                    >
                      <i className="mdi mdi-lock-alert me-1 font-size-16"></i>
                      {approvalStatus === "pending" ? "Edit Request Pending Admin Review" : "Request Edit Authorization"}
                    </button>
                  ) : (
                    <button
                      style={{ height: "60px" }}
                      className="btn btn-secondary fw-bold"
                      type="button"
                      onClick={onDrawerClose}
                    >
                      Close View
                    </button>
                  )
                ) : !submitLoding ? (
                  <button
                    style={{ height: "60px" }}
                    className="btn btn-primary fw-bold font-size-16"
                    type="submit"
                    disabled={order.products.length <= 0}
                    onClick={() => {
                      addOrderMethods()
                    }}
                  >
                    {isEditData ? "Update Order" : "Submit"}
                  </button>
                ) : (
                  <button style={{ height: "60px" }} className="btn btn-primary" disabled>
                    <i className="fas fa-spinner fa-spin me-2" /> Saving...
                  </button>
                )}
              </div>
              {/* END ROW_2 */}
            </div>

            {/* Modal Popup */}
            {modalType != "sub_doctor" && isOpenModal && (
              <Modal
                zIndex="9999"
                size={modalType == "add_product" ? "xl" : "lg"}
                isOpen={isOpenModal}
                toggle={() => setIsOpenModal(!isOpenModal)}
              >
                <div className="modal-header">
                  <h5 className="modal-title mt-0" id="myModalLabel">
                    {getTitle(modalType)}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  {modalType == "add_product" && (
                    <AddProduct
                      products={getProducts}
                      clientData={clientData}
                    />
                  )}
                  {modalType == "enclosure" && (
                    <Trials
                      _enclosures={order?.enclosure}
                      enclosuresCB={encCB}
                    />
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    onClick={() => {
                      setIsOpenModal(!isOpenModal)
                    }}
                    className="btn btn-secondary "
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </Modal>
            )}

            {/* Sub Doctor Add Modal */}
            {modalType == "sub_doctor" && isOpenModal && (
              <SubDoctor
                data={clientData}
                isOpenModal={isOpenModal}
                callback={() => {
                  getSubDoctors(clientData?.code)
                  setModalType(false)
                  setIsOpenModal(false)
                }}
                closeModal={() => setIsOpenModal(false)}
              />
            )}

            <Modal
              isOpen={patientOldOrdes?.length > 0}
              role="dialog"
              autoFocus={true}
              centered
              size="xl"
              zIndex="9999"
              toggle={() => setPatientOldOrdes(null)}
            >
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                  Patient Details
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Order Date</th>
                      <th>Order #</th>
                      <th>Case #</th>
                      <th>Tooth</th>
                      <th>Product</th>
                      <th>Product type</th>
                      <th>Product category</th>
                    </tr>
                  </thead>
                  <tbody>
                    {patientOldOrdes?.map((v, i) => (
                      <tr key={`PO_${i}`}>
                        <td>{i + 1}</td>
                        <td>{moment(v.in_date).format("DD-MM-YYYY")}</td>
                        <td>{v.order_number}</td>
                        <td>{v.case_no}</td>
                        <td>{JSON.parse(v.product_teeth).join(", ")}</td>
                        <td>{v.product_title}</td>
                        <td>{v.productcategory_title}</td>
                        <td>{v.producttype_title}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* <PatientDetails patient={patient} /> */}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  title="Create order"
                  className="btn btn-primary"
                  onClick={() => {
                    setPatientOldOrdes(null)
                  }}
                >
                  Continue
                </button>
                <button
                  type="button"
                  title="Back to New Order"
                  className="btn btn-success"
                  onClick={() => onDrawerClose()}
                >
                  {" "}
                  Back to New Order
                </button>
              </div>
            </Modal>
          </>
        ) : (
          <h3 className="p-4">
            <i className="me-2 fas fa-spinner fa-spin" />
            form loading...
          </h3>
        )}
      </Drawer>
    </>
  )
}

export default OrderForm
